<template>
    <div class="grid p-fluid">
      <!-- {{servicedata}} -->
      <div class="col-12 md:col-12"><Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems">
                <!--<template #item="{ item, props }">
                    <router-link v-if="item.to" v-slot="{ href, navigate }" :to="item.to" custom>
                        <a :href="href" v-bind="props.action" @click="navigate">
                            <span :class="[item.icon, 'text-color']" />
                            <span class="text-primary font-semibold">{{ item.label }}</span>
                        </a>
                    </router-link>
                </template>-->
            </Breadcrumb></div>
      <div class="col-12 md:col-4">
        <div class="card card-w-title" style="height: 800px">
          <div style="col-12 md;text-align:center">
            <img v-if="servicedata.profile_image"
              :src="servicedata.profile_image"
              style="width: 200px;height:200px; border-radius: 20%"
            />
            <img v-else
              src="https://media.istockphoto.com/vectors/no-image-available-icon-vector-id1216251206?k=6&m=1216251206&s=612x612&w=0&h=G8kmMKxZlh7WyeYtlIHJDxP5XRGm9ZXyLprtVJKxd-o="
              style="width: 200px; border-radius: 20%"
            />
            <hr />
          </div>
          <div style="">
            <div class="grid">
              <!-- <div class="row"> -->
              <div class="col-4 md:col-4"><b>Status</b> </div>
              <div class="col-8 md:col-8">{{servicedata.status}}</div>
              <div class="col-4 md:col-4"><b>Tittle</b></div>
              <div class="col-8 md:col-8">{{servicedata.title}}</div>
              <div class="col-4 md:col-4"><b>Service Name</b></div>
              <div class="col-8 md:col-8">{{servicedata.service_name}}</div>
               <div class="col-4 md:col-4"><b>Service Name</b></div>
              <div class="col-8 md:col-8">{{servicedata.service_type_name}}</div>
             <div class="col-4 md:col-4"><b>Registratio No.</b></div>
              <div class="col-8 md:col-8">{{servicedata.registration_number}}</div>
              <div class="col-4 md:col-4"><b>Pincode</b></div>
              <div class="col-8 md:col-8">{{servicedata.pincode}}</div>
              <div class="col-4 md:col-4"><b>Address</b></div>
              <div class="col-8 md:col-8" v-if="servicedata.address">{{servicedata.address}} {{servicedata.city}} {{servicedata.state}} {{servicedata.pincode}}</div>
              <div class="col-8 md:col-8" v-else></div>
  
              <!-- </div> -->
            </div>
            <!-- <div class="row"><div style="col-4 md;"><b>Name :</b></div>
                          <div style="col-8 md;">Prathamesh Tamboli</div></div>
                           <div class="row"><div style="col-4 md;"><b>Name :</b></div>
                          <div style="col-8 md;">Prathamesh Tamboli</div></div> -->
          </div>
        </div>
      </div>
      <div class="col-12 md:col-8">
        <div class="card card-w-title" style="height: 800px">
      <!-- {{servicedata}} -->
            <tabs
      v-model="selectedTab"
    >
    <!-- {{tabs}} -->
      <tab
        class="tab"
        v-for="(tab, i) in tabs"
        :key="`t${i}`"
        :val="tab"
        :label="tab"
        :indicator="true"
      />
    </tabs>
      <tab-panels
      v-model="selectedTab"
      :animate="true"
    >
      <tab-panel >
        <!-- {{selected_tab}} -->
        <loading
              :active="isLoadingModel"
              :can-cancel="true"
              
              color="#274461"
              :is-full-page="fullPage"
            ></loading>
        
           
        <UserServiceRequest :service_id="service_id"
                            :data_id="data_id"
                            :user_id="user_id"
        v-if="selectedTab=='Service Request' && data_id && user_id && service_id"></UserServiceRequest>
     
        
      </tab-panel>
    </tab-panels>
  
          
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { Tabs, Tab, TabPanels, TabPanel } from 'vue3-tabs';
  import UserServiceRequest from '../components/menu/User_Service_Request'
  import BreadcrumbService from "../service/BreadcrumbService";


  

  import apis from "@/apis";
  
  
  export default {
    data() {
      return {
          active:"active",
          tabs : ['Service Request'],
          selectedTab: "Service Request",

          servicedata:[],
          service_id:'',
          data_id:'',
          user_id:'',
          
          isLoadingModel:false,
          BreadcrumbService : null,
breadcrumbHome: {},
breadcrumbItems: [],
      };
    },
    async mounted(){
      
      if(localStorage.getItem('saveservicedata'))
      {
         this.servicedata=await JSON.parse(localStorage.getItem('saveservicedata'));
      
         
         this.service_id= await this.servicedata.service_id;
         this.data_id=await this.servicedata._id;
         this.user_id=await this.servicedata.user_id;
       
   
      
      }
      await localStorage.setItem('saveservicedata','')
      
      
    },
    async created(){
      this.BreadcrumbService = new BreadcrumbService();
	let Breadcrum_data = this.BreadcrumbService.serviceProfile()
	this.breadcrumbHome=Breadcrum_data.home;
	this.breadcrumbItems=Breadcrum_data.items;
      
    },
    methods: {

      
    
      D_M_Y_formatDate(date_parm)
      {
        if(date_parm)
        {
          let date = new Date(date_parm);
          let dd = date.getDate();
          let mm = date.getMonth() + 1;
          let yyyy = date.getFullYear();
          let new_date = dd+"-"+mm + "-" + yyyy ;
          // alert(dd)
          if(dd.toString()!="NaN")
          {
            //this.receipt_new_date = new_date;
            return new_date;
          }
          else
          {
            return date_parm;
          }
        }
      },
      toggleMenu(event) {
        this.$refs.menu.toggle(event);
      },
      onContextRightClick(event) {
        this.$refs.contextMenu.show(event);
      },
    },
    components:{
          Tabs,
      Tab,
      TabPanels,
      TabPanel,

      UserServiceRequest,
  
      
    }
  };
  </script>